import React from 'react';
import { HelpingRoutes, PageRoute } from '../../../models';
import { NavLink } from '../NavLink';
import styles from './HelpSectionMobile.scss';

const HelpSectionMobile = () => (
  <div className={styles.container}>
    <NavLink
      title={"Banner oglašavanje"}
      path={`${PageRoute.help}/${HelpingRoutes.advertising}`}
    />

     <NavLink 
        title={"Načini plaćanja"}
        path={`${PageRoute.help}/${HelpingRoutes.paymentMethods}`}
      />

    <NavLink
      title={"Uvjeti korištenja"}
      path={`${PageRoute.help}/${HelpingRoutes.termsOfUse}`}
    />

    <NavLink
      title={"Pravila za predaju oglasa"}
      path={`${PageRoute.help}/${HelpingRoutes.instructionsForUse}`}
    />

    <NavLink
      title={"Pravila o privatnosti"}
      path={`${PageRoute.help}/${HelpingRoutes.privacyPolicy}`}
    />

    <NavLink
      title={"Često postavljana pitanja"}
      path={`${PageRoute.help}/${HelpingRoutes.faq}`}
    />

    <a href={HelpingRoutes.index}
        target="_blank"
      className={styles.externalLink}
      >
        {"Index.hr"}
      </a>

  </div>
);

export default HelpSectionMobile;



// WEBPACK FOOTER //
// ./src/components/Footer/HelpSectionMobile/HelpSectionMobile.tsx